import './_terms.scss';

const AcceptableUse = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
            Acceptable Use
            </h2>
          <div className="pf-content__description">
            <p>
            This acceptable use policy applies to your use of <strong>AllFans</strong> and forms part of your agreement 
            with us. This policy sets out the content standards that apply when you upload Content to <strong>AllFans</strong>, 
            contact other Users of <strong>AllFans</strong>, link to <strong>AllFans</strong>, or interact 
            with <strong>AllFans</strong> in any other way. In this policy, defined terms have the same meanings as in our <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
            </p>
          </div>
          <ol className="pf-main-list">
            <li>
              <p>You must not use AllFans except for your own personal use and must not sell, rent, transfer, 
                or share your account or any Content obtained from your use of AllFans to or with anyone else.</p>
            </li>
            <li>
                <p>You must only use AllFans in a way and for a purpose that is lawful.</p>
            </li>
            <li>
                <p>You must not upload, post, display, or publish Content on AllFans that is illegal, fraudulent, 
                    defamatory, hateful, discriminatory, threatening, or harassing or that encourages or promotes violence 
                    or any illegal activity.</p>
            </li>
            <li>
                <p>You must not use AllFans in any way that might exploit, harm, or try to exploit or harm any
                     individual under 18, for example, by exposing them to inappropriate Content.</p>
            </li>
            <li>
                <p>You must not upload, post, display, or publish Content on AllFans that:</p>
              <ol>
                <li>shows, includes, or refers to:
                    <ol className="ol-decimal">
                    <li>any individual under 18 (or that refers to individuals under 18 generally); or</li>
                    <li>any other individual unless you have written documentation that confirms that all individuals 
                        shown or included or referred to in your Content are at least 18, and you have written consent from 
                        each individual to use their name or images (or both) in the Content;</li>
                    </ol>
                </li>
                <li>
                  <p>shows, promotes, advertises, or refers to:</p>
                    <ol className="ol-decimal">
                    <li>firearms, weapons, or any goods whose sale, possession, or use is subject to prohibitions or restrictions;</li>
                    <li>drugs or drug paraphernalia;</li>
                    <li>self-harm or suicide;</li>
                    <li>incest;</li>
                    <li>bestiality;</li>
                    <li>violence, rape, lack of consent, hypnosis, intoxication, sexual assault, torture, sadomasochistic abuse 
                        or hardcore bondage, extreme fisting, or genital mutilation;</li>
                    <li>necrophilia;</li>
                    <li>urine, scatological, or excrement-related material;</li>
                    <li>“revenge porn” (being any sexually explicit material featuring any individual who has not given prior, 
                        express, and informed consent to that material (i) being taken, captured, or otherwise memorialized; or (ii) 
                        being posted and shared on AllFans);</li>
                    <li>escort services, sex trafficking, or prostitution;</li>
                    </ol>
                </li>
                <li>
                  <p>
                    contains unsolicited sexual Content or unsolicited language that sexually objectifies another User or anyone 
                    else in a nonconsensual way or contains fake or manipulated sexual Content regarding another User or anyone 
                    else (including “deepfakes”);
                  </p>
                </li>
                <li>
                    <p>
                     contains, promotes, advertises, or refers to hate speech (being Content intended to vilify, humiliate, 
                     dehumanize, exclude, attack, threaten, or incite hatred, fear of, or violence against a group or individual
                      based on race, ethnicity, national origin, immigration status, caste, religion, sex, gender identity or 
                      expression, sexual orientation, age, disability, disease, veteran status, or any other protected characteristic);   
                    </p>
                </li>
                <li>
                    <p>
                     contains or refers to anyone else’s personal information or private or confidential information (for example, 
                     telephone numbers, location information (including street addresses, and GPS coordinates), names, identity 
                     documents, email addresses, login credentials for AllFans including passwords and security questions, 
                     financial information including bank account and credit card details, biometric data, and medical records) 
                     without that person’s express written consent;  
                    </p>
                </li>
                <li>
                    <p>either:</p>
                    <ol className="ol-decimal">
                        <li>
                            <p>for Content featuring public nudity, was recorded in or is being broadcast from a jurisdiction where public 
                                nudity is illegal; or</p>
                        </li>
                        <li>
                            <p>for Content featuring sexual activities, was recorded in or is being broadcast from a public place where
                                 members of the public are reasonably likely to see the activities being performed (this does not include 
                                 outdoor places where members of the public are not present, for example, private property including a private 
                                 backyard, or secluded areas in nature where members of the public are not present);</p>
                        </li>
                    </ol>
                </li>
                <li>
                    <p>
                        gives the impression that it comes from or is approved, licensed, or endorsed by us or any other person or company;
                    </p>
                </li>
                <li>
                    <p>
                        causes or is calculated to cause inconvenience or anxiety to anyone else or that is likely to upset, embarrass, 
                        or cause serious offense to anyone else;
                    </p>
                </li>
                <li>
                    <p>
                        is used or is intended to be used to extract money or another benefit from anyone else in exchange for the removal of the Content; or
                    </p>
                </li>
                <li>
                    <p>
                        involves or promotes nonparty commercial activities or sales, including contests, sweepstakes, and 
                        other sales promotions, product placements, advertising, or job posting or employment ads without our 
                        prior express consent.
                    </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                You must not use AllFans to stalk, bully, abuse, harass, threaten, or intimidate anyone else.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans to engage in misleading or deceptive conduct or conduct likely to 
                mislead or deceive any other User.
              </p>
            </li>
            <li>
              <p>
                You must respect the intellectual property rights of Creators, including by not recording, reproducing, 
                sharing, communicating to the public, or otherwise distributing their Content without permission.
              </p>
            </li>
            <li>
              <p>
                You must do nothing that violates our or someone else’s rights, including intellectual property 
                rights (examples of which are copyright, trademarks, confidential information, and goodwill), personality 
                rights, unfair competition, privacy, and data protection rights.
              </p>
            </li>
            <li>
              <p>
                You must not impersonate us, one of our employees, another User, or any other person or company 
                or falsely state or suggest any affiliation, endorsement, or sponsorship between you and us or any 
                other person or company.
              </p>
            </li>
            <li>
              <p>
                You must not provide false account registration information or make unauthorized use of anyone 
                else’s information or Content.
              </p>
            </li>
            <li>
              <p>
                You must not post or cause to be posted any Content that is spam, has the intention or effect 
                of artificially increasing any Creator’s views or interactions, or is otherwise inauthentic, 
                repetitive, misleading, or low quality.
              </p>
            </li>
            <li>
              <p>
                You must not transmit, stream, or otherwise send any prerecorded audio or video material 
                during a live stream or otherwise try to pass off recorded material as a live stream.
              </p>
            </li>
            <li>
              <p>
                You must not use other media or methods (for example, using codewords or signals) 
                to communicate anything that violates this policy.
              </p>
            </li>
            <li>
              <p>
                You must not reproduce, print, distribute, try to download, modify, create 
                derivative works of, publicly display, publicly perform, republish, download, store, 
                or transmit any Content, except as permitted under the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a>.
              </p>
            </li>
            <li>
              <p>
                You must not knowingly introduce any viruses, trojans, worms, logic bombs, or other 
                material into Content that is or might be malicious or technologically harmful.
              </p>
            </li>
            <li>
              <p>
                You must not decompile, disassemble, reverse engineer, or otherwise try to 
                discover or derive the source code of AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans in a way that could adversely affect our systems 
                or security or interfere with any other User’s use of AllFans, including their 
                ability to engage in real-time activities through AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use any automated program, tool, or process (including web crawlers, 
                robots, bots, spiders, and automated scripts) to access AllFans or any server, 
                network, or system associated with AllFans, or to extract, scrape, collect, 
                harvest, or gather Content or information from AllFans.
              </p>
            </li>
            <li>
              <p>
                You must not use AllFans’s name, logo, or any related or similar names, 
                logos, product and service names, designs, or slogans other than in the limited ways expressly 
                permitted in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> or with our prior written agreement.
              </p>
            </li>
          </ol>
          <p className='note'>Breaches of this policy may lead to your account being suspended or terminated and access 
            to your earnings being revoked, as set out in the <a href='/terms' className='terms-link'>Terms-of-Service Agreement</a> and <a href='/creatorterms' className='terms-link'>Creator Terms</a>.</p>

          </div>
          <div style={{ paddingTop: '240px' }}></div>
          </div>

          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default AcceptableUse;
